var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProspectsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ProspectsSmall_svg__[object_Object]a",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7793FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1877F2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#ProspectsSmall_svg__[object_Object]a)",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE4FE",
    d: "M19.781 12.316l-1.597-2.94a2.365 2.365 0 00-1.232-1.012A2.305 2.305 0 0014.815 7a2.303 2.303 0 00-2.116 1.395 1.619 1.619 0 00-1.418 0A2.302 2.302 0 009.15 7c-.936 0-1.78.552-2.132 1.395-.49.196-.899.544-1.161.992L4.61 11.594a3.384 3.384 0 00.051 3.95c.864 1.178 2.39 1.71 3.826 1.335 1.437-.376 2.483-1.579 2.624-3.018a3.415 3.415 0 00-.054-1.021 3.349 3.349 0 00-.123-.42c.195-.39.602-.638 1.048-.638.446 0 .852.248 1.048.637-.05.138-.091.279-.123.422a3.415 3.415 0 00-.054 1.01c.127 1.344 1.044 2.494 2.351 2.947a3.637 3.637 0 003.74-.834c.973-.962 1.325-2.385.836-3.648zM7.546 15.958c-1.257-.004-2.305-.902-2.424-2.075-.118-1.174.732-2.24 1.966-2.465 1.234-.226 2.449.464 2.809 1.593.069.213.103.434.103.656-.004 1.268-1.102 2.293-2.454 2.291zM14 13.668a2.115 2.115 0 01.102-.658c.314-.97 1.265-1.632 2.343-1.635a2.504 2.504 0 011.773.72h.01l.127.144c.586.688.7 1.632.292 2.425-.408.794-1.264 1.297-2.202 1.294-1.347.001-2.441-1.023-2.445-2.29z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectsSmall);
export default ForwardRef;